import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'

// state
const state = {
	statsData: {},
	statsFilter: {
		startDate: moment().startOf('isoWeek').format('MM-DD-YYYY'),
		endDate: moment().endOf('isoWeek').format('MM-DD-YYYY')
	},
	selectedParam: 'This Month', //default to week
}

const getters = {

}


// mutations
const mutations = {
	SET_SELECTED_STATS(state, selectedItem){
		var selectedDisplayItem;
		// save to sessionStorage for page refresh usage.
		sessionStorage.setItem("ACTIVE-STATS", selectedItem);
		
		switch(selectedItem){
			case 'today':
				var todayDate = moment().format('MM-DD-YYYY');
				state.statsFilter['startDate'] = todayDate;
				state.statsFilter['endDate'] = todayDate;
				selectedDisplayItem = 'Today';
				break;
			case 'week':
				var startDate = moment().startOf('isoWeek').format('MM-DD-YYYY');
				var endDate = moment().endOf('isoWeek').format('MM-DD-YYYY');
				state.statsFilter['startDate'] = startDate;
				state.statsFilter['endDate'] = endDate;
				selectedDisplayItem = 'This Week';
				break;
			case 'month':
				var startDate = moment().startOf('month').format('MM-DD-YYYY');
				var endDate = moment().endOf('month').format('MM-DD-YYYY');
				state.statsFilter['startDate'] = startDate;
				state.statsFilter['endDate'] = endDate;
				selectedDisplayItem = 'This Month';
				break;
			case 'year':
				var startDate = moment().startOf('year').format('MM-DD-YYYY');
				var endDate = moment().endOf('year').format('MM-DD-YYYY');
				state.statsFilter['startDate'] = startDate;
				state.statsFilter['endDate'] = endDate;
				selectedDisplayItem = 'This Year';
				break;
		}

		state.selectedParam = selectedDisplayItem

	},

	SET_STATS_DATA(state, data){
		state.statsData = data
	}
}

// actions
const actions = {
	setSelectedStats({commit, dispatch}, selectedItem){
		commit('SET_SELECTED_STATS', selectedItem);
		dispatch('getVendorStats');
	},

	getVendorStats({commit, dispatch, state, getters, rootState, rootGetters}){
		// call api to get vendor stats
		var header = rootState.auth.header;
		var statsData = state.statsFilter;

		var url = rootState.auth.l+'v1/get-vendor-stats/';

        $.ajax({
        	url: url,
			data: statsData,
			type: 'GET',
			beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a);},
         	success: function(response) {
         		//console.log(response);
         		commit('SET_STATS_DATA', response);
         	},
			error: function (xhr, ajaxOptions, error) {
				console.log(xhr);
			}
        });
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}